import {
  Directive,
  Input,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit,
  AfterViewInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Subject } from 'rxjs';
import { delay, filter } from 'rxjs/operators';

//adapted from https://giancarlobuomprisco.com/angular/intersection-observer-with-angular

//see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
export interface ObserveVisibilityOptions extends IntersectionObserverInit {
  // debounceTime?: number; //ms
  enabled?: boolean;

  /// Debounce time in milliseconds for the visibility event
  debounceTimeMs?: number; //ms
}

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[observeVisibility]',
    standalone: false
})
export class ObserveVisibilityDirective implements OnDestroy, OnInit, AfterViewInit, OnChanges {

  @Input() observeVisibility: ObserveVisibilityOptions | null = null;

  @Output() visible = new EventEmitter<HTMLElement>();

  private observer: IntersectionObserver | undefined;
  private subject$ = new Subject<{ entry: IntersectionObserverEntry; observer: IntersectionObserver; }>();

  constructor(private element: ElementRef) { }

  ngOnInit() {

    this.subject$
      .pipe(
        delay(this.observeVisibility?.debounceTimeMs || 0),
        filter(Boolean)
      )
      .subscribe(({ entry, observer }) => {
        const target = entry.target as HTMLElement;
        // this.isVisible(target).then(isStillVisible => {
        //   if (isStillVisible) {
        this.visible.emit(target);
        observer.unobserve(target);
        //   }
        // });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['observeVisibility']) {
      if (this.observeVisibility?.enabled) {
        this.createObserver();
      }
      else {
        this.destroyObserver();
      }
    }
  }

  ngAfterViewInit() {
    if (this.observeVisibility?.enabled) {
      this.createObserver();
    }
  }

  ngOnDestroy() {
    this.destroyObserver();

    this.subject$.next(null);
    this.subject$.complete();
  }

  private destroyObserver() {
    if (this.observer) {
      this.observer.unobserve(this.element.nativeElement);
      this.observer.disconnect();
      this.observer = undefined;
    }
  }

  // private isVisible(element: HTMLElement) {
  //   return new Promise(resolve => {
  //     const observer = new IntersectionObserver(([entry]) => {
  //       resolve(entry.intersectionRatio === 1);
  //       observer.disconnect();
  //     });

  //     observer.observe(element);
  //   });
  // }

  private createObserver() {

    // in case of re-creation, release previous one
    this.destroyObserver();

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          this.subject$.next({ entry, observer });
        }
      });
    }, this.observeVisibility);

    this.observer.observe(this.element.nativeElement);

  }

}
